import { Button, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { packageFilterFormField, PackageFilterFormValues } from './type';
const { useBreakpoint } = Grid;

type UsersWithWalletFilterFormProps = {
  formId: string;
  handleFilter: (values: PackageFilterFormValues) => void;
  initialValues: PackageFilterFormValues;
  closeModal?: () => void;
};

export const PackageFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: UsersWithWalletFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<PackageFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const onReset = () => {
    form.resetFields();
    handleFilter({ ...initialValues });
  };

  const handleOnFinish = (values: PackageFilterFormValues) => {
    handleFilter(values);
    // setQueryFilters(values);
    closeModal?.();
  };

  return (
    <>
      <Form<PackageFilterFormValues>
        id={formId}
        name={formId}
        form={form}
        layout='vertical'
        onFinish={handleOnFinish}
        initialValues={initialValues}
        onFinishFailed={() => {
          setValidateTrigger(['onChange']);
        }}
        validateTrigger={validateTrigger}
      >
        <ContentFilters.FormItemsWrapper>
          <StandardItemsWrapper>
            <Form.Item<PackageFilterFormValues>
              label={t('package.formfield.type.label')}
              name={packageFilterFormField.type}
            >
              <Select
                style={{ width: 120 }}
                placeholder='All'
                options={[
                  { value: 0, label: 'All' },
                  { value: '1', label: 'Monthly' },
                  { value: '2', label: 'Sessions' },
                ]}
              />
            </Form.Item>
            <Form.Item<PackageFilterFormValues>
              label={t('package.formfield.packagename.label')}
              name={packageFilterFormField.packagename}
            >
              <Input
                placeholder={t('package.formfield.packagename.placeholder')}
              />
            </Form.Item>
          </StandardItemsWrapper>
        </ContentFilters.FormItemsWrapper>

        {screens.lg && (
          <ContentFilters.ButtonsWrapper>
            <Button type='primary' htmlType='submit'>
              {t('wallet.buttons.filter', { count: 1 })}
            </Button>
            <Button onClick={onReset}>{t('wallet.buttons.reset')}</Button>
          </ContentFilters.ButtonsWrapper>
        )}
      </Form>
    </>
  );
};
